<template>
  <div>
    <v-container grid-list-md fluid class="ma-0 pa-0 pb-3">
      <v-layout row wrap >
        <CompanySelector @dataChanged="loadData()"/>
      </v-layout>
    </v-container>
     
  
    <div v-if="$store.state.activeBranchData.qcare && $store.state.activeBranchData.qcare.active" class="qcare-wrapper">
        <v-tabs background-color="background" show-arrows :color="companyPrimaryColor">
          <v-tab :color="companyPrimaryColor" @click="showOverview()">Gesprekken</v-tab>
          <v-tab :color="companyPrimaryColor" @click="showCalendar()">Agenda</v-tab> 
        </v-tabs>

        <v-tabs-items v-model="tab" background-color="background">
          <v-tab-item value="1" :transition="tabTransition" :reverse-transition="tabTransition" background-color="background">      
            <v-container grid-list-md class="px-0 pt-2 align-center" fluid>
              <v-layout row wrap>
                <v-flex v-if="eventsToday.length > 0" sm6 xs12>
                  <div v-for="(event, index) in eventsToday" :key="index + eventChanges" v-if="!loading">
                    <v-card flat :color="getEventColor(event)" style="height: 110px;" dark class="pa-2 px-0 mb-2" @click="openEvent({event})">
                      <v-card-title dark class="py-0" >
                        <!-- <v-icon
                          small 
                          left
                        >
                        mdi-clock
                        </v-icon> -->
                        <v-container class="pa-0 ma-0">
                     


                        <v-row class="pa-0" align="center">
                          <v-col cols="3" class="py-0" style="max-width: 30px;">
                            <v-icon
                          small 
                          left
                        >
                        mdi-clock
                        </v-icon>
                          </v-col>
                      <v-col  class="py-0 flex-grow-1">
                        <span style="font-size: 14px; color: #fff">{{ formatDate(event.start, 'YYYY_MM_DDTHH:mm', 'HH:mm') }}-{{ formatDate(event.end, 'YYYY_MM_DDTHH:mm', 'HH:mm')  }}u</span>
                      </v-col>
                      <v-col cols="3" class="pt-0 pb-0 text-right" style="max-width: 30px;">
                        <div v-if="event.type !=='occupied'">
                        <v-icon small color="white" v-if="event.status == 'open'">mdi-checkbox-blank-outline</v-icon>
                        <v-icon small color="white" v-if="event.status == 'inProgress'">mdi-progress-clock</v-icon>
                        <v-icon small color="white" v-if="event.status == 'closed'">mdi-checkbox-marked-outline</v-icon>
                        <v-icon small color="red" v-if="event.status == 'cancelled'">mdi-cancel</v-icon>
                      </div>
                      </v-col>
                    </v-row>
                  </v-container>
                      </v-card-title>

                      <v-card-title dark style="font-size: 16px; color: #fff" class="pt-0" v-if="event.title" >{{ event.title }}</v-card-title>
                      <v-card-title color="text" style="font-size: 16px; color: #fff" class="pt-0"  v-else>{{ getEventType(event.type) }}</v-card-title>
                      <v-card-subtitle >{{ event.phoneNumber }}</v-card-subtitle>
                      <v-card-subtitle >{{ event.notes }}</v-card-subtitle>
                      
                    </v-card>
                  </div>
                  
                </v-flex>
                <v-flex v-else  xs12>
                  <div class="text-center pa-10">
                    <v-icon size="30px" :color="companyPrimaryColor">mdi-calendar-blank</v-icon>
                    <h4 class="mt-2">Geen activiteiten vandaag</h4>
                  </div>
                
                </v-flex>

                <v-flex sm6 xs12>
                  
                </v-flex>
              </v-layout>
            </v-container>
        
          </v-tab-item>
          <v-tab-item value="2" :transition="tabTransition" :reverse-transition="tabTransition">
            <v-card outlined class="mt-1">
              <v-container grid-list-md class="px-0 pt-0 align-center" fluid>
                <v-layout row wrap>
                  <v-flex md4 xs12></v-flex>
                  <v-flex md4 xs12 class="text-center">
                    <b>Week {{selectedWeek.number}}</b><br>
                    <span style="font-size: 12px">{{formatDate(selectedWeek.start, 'YYYY-MM-DD', 'D-MM-YYYY')}} t/m  {{formatDate(selectedWeek.end, 'YYYY-MM-DD', 'D-MM-YYYY')}}</span>   
                  </v-flex>
                  <v-flex md4 xs12 class="text-right align-center d-flex"> 
                    <div style="width: 100%;">
                      <v-btn icon color="primary"@click="navigate('previous')">
                        <v-icon>mdi-chevron-left</v-icon>
                      </v-btn>
                      <v-menu
                        ref="dateSelectorMenu"
                        v-model="dateSelectorMenu"
                        :close-on-content-click="false"
                        offset-y
                        left
            
                        max-width="290px"
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn icon color="primary" class="mx-3" v-on="on"  v-bind="attrs">
                            <v-icon>mdi-calendar</v-icon>
                          </v-btn>
                        </template>
                        <v-date-picker
                          v-model="selectedDate"
                          no-title
                          color="primary"
                          @input="dateSelectorMenu = false, navigate('date')"
                        ></v-date-picker>
                      </v-menu>

                      <v-btn icon color="primary" @click="navigate('next')">
                        <v-icon>mdi-chevron-right</v-icon>
                      </v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>

              <v-calendar
                style="border-left: none; border-right: none; border-radius: 0!important"
                v-model="selectedDate"
                ref="calendar"
                :events="events"
                color="primary"
                @mousedown:event="startDrag"
                :event-color="getEventColor"
                @mousedown:time="startTime"
                @mousemove:time="mouseMove"
                @mouseup:time="endDrag"
                :interval-height="80"
                :interval-minutes="$store.state.activeBranchData.qcare.timeBlock"
                :interval-format="intervalFormat"
                @mouseleave.native="cancelDrag"
                type="week"
                :first-time="dayTime.start"
                :last-time="dayTime.end"
                :interval-count="dayTime.intervalCount"
                >

    
                <template v-slot:day-label-header="{ date, present }">
                  <template class="text-center">
                    <v-row>
                      <v-col sm="12" class="text-center">
                        <div style="text-transform: uppercase; font-size: 11px" :class="{ 'custom-calendar-today': present }">
                          {{ formatDate(date, 'YYYY-MM-DD', 'dddd') }}
                        </div>
                        <div style="font-weight: bold" :class="{ 'custom-calendar-today': present }">{{ formatDate(date,'YYYY-MM-DD', 'D MMMM') }}</div>
                      </v-col>
                    </v-row>
                  </template>
                </template>

                <template v-slot:day-body="{ date, week }">
                  <div 
                    class="v-current-time"
                    :class="{ first: date === week[0].date }"
                    :style="{ top: nowY }">
                  </div>
                </template>

                <template v-slot:interval="{ time, date }">
                  <div style="width: 100%; height: 100%;" :class="{ 'inactive-interval': !checkForActive(date, time)}">
                  </div>
                </template>

                <template v-slot:event="{ event, timed, eventSummary  }">
                  <div class="event-info-wrapper" @click="openEvent({event})">
                    <v-container class="pa-0 ma-0">
                    <v-row class="pa-0">
                      <v-col sm="6" class="py-1">
                        <div class="event-info-banner-time">{{ event.start | moment("H:mm") }} - {{ event.end | moment("H:mm") }}u</div>
                      </v-col>
                      <v-col sm="6" class="pt-0 pb-1 text-right">
                        <div v-if="event.type !=='occupied'">
                        <v-icon small color="white" v-if="event.status == 'open'">mdi-checkbox-blank-outline</v-icon>
                        <v-icon small color="white" v-if="event.status == 'inProgress'">mdi-progress-clock</v-icon>
                        <v-icon small color="white" v-if="event.status == 'closed'">mdi-checkbox-marked-outline</v-icon>
                        <v-icon small color="red" v-if="event.status == 'cancelled'">mdi-cancel</v-icon>
                      </div>
                      </v-col>
                    </v-row>
                  </v-container>
 

                    <div class="event-info-banner" v-if="event.title || event.type">
                      <div v-if="event.title" class="event-info-banner-title">{{ event.title }}</div>
                      <div v-else class="event-info-banner-title">{{ getEventType(event.type) }}</div>

                    </div>
                    <div class="event-info-description">
                      {{ event.notes }}
                    </div>
                    <div class="event-info-phone" v-if="event.type != 'occupied' && event.phoneNumber">
                      <v-icon small color="white" class="mr-1">mdi-phone</v-icon>
                      <a :href="'tel:'+event.phoneNumber">{{ event.phoneNumber }}</a>
                    </div>
                    <!-- <div
                        v-if="timed"
                        class="v-event-drag-bottom"
                        @mousedown.stop="extendBottom(event)"
                      ></div> -->
                  </div>
                </template>
              </v-calendar>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      

        <v-dialog v-model="eventData.dialog" scrollable max-width="450px" @click:outside="closeEventData()">
          <v-card v-if="eventData.type">
            <v-card-title class="pr-2" :style=" { backgroundColor: companyPrimaryColor }">
              <div v-if="eventData.dialogType == 'edit'">
                <h3 v-if="eventData.title" style="color:white">{{ eventData.title }} bewerken</h3>
              <h3 v-else style="color:white">{{ getEventType(eventData.type) }} bewerken</h3>
              </div>
              <div v-if="eventData.dialogType == 'new'">
                <h3 v-if="eventData.title" style="color:white" c>{{ eventData.title }} toevoegen</h3>
                <h3 v-else style="color:white">{{ getEventType(eventData.type) }} toevoegen</h3>
              </div>
              
              <v-spacer></v-spacer>
              <v-btn icon dark @click="closeEventData()">
                <v-icon dark color="white">close</v-icon>
              </v-btn>
            </v-card-title>

            <v-alert
              class="pa-1 ma-0"
              v-if="eventData.feedback"
              :value="true"
              tonal
              type="warning"
              >
              {{ eventData.feedback }} 
            </v-alert>

            <v-divider></v-divider>

            <v-card-text class="pa-0">
              <v-form ref="editBranchForm" lazy-validation>
                <v-container  grid-list-md fluid class="ma-0 pa-3">
                  <v-layout row wrap>

                    <v-flex xs12>
                      <v-text-field
                      v-if="eventData.type != 'callFlow'"
                        class="pt-2"
                        label="Titel"
                        v-model="eventData.title"
                        :color="companyPrimaryColor"
                        background-color="background"
                        hide-details
                        outlined
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        class="mt-4"
                        hide-details
                        outlined
                        :color="companyPrimaryColor"
                        :item-color="companyPrimaryColor"
                        v-model="eventData.type"
                        :items="eventTypes"
                        label="Type"
                        ackground-color="background"
                        item-text="name"
                        item-value="id"
                      ></v-select>
                    </v-flex>

                    <v-flex xs12>
                      <v-text-field
                        class="pt-2"
                        label="Telefoonnummer"
                        v-model="eventData.phoneNumber"
                        :color="companyPrimaryColor"
                        background-color="background"
                        hide-details
                        outlined
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        rows="3"
                        class="pt-2"
                        label="Notities"
                        v-model="eventData.notes"
                        :color="companyPrimaryColor"
                        background-color="background"
                        hide-details
                        outlined
                        required
                      ></v-textarea>
                    </v-flex>

                    <v-flex xs12 v-if="eventData.dialogType == 'edit' && eventData.type !== 'occupied'">
                      <v-select
                        class="mt-4"
                        hide-details
                        outlined
                        :color="companyPrimaryColor"
                        :item-color="companyPrimaryColor"
                        v-model="eventData.status"
                        :items="statusTypes"
                        label="Status"
                        ackground-color="background"
                        item-text="name"
                        item-value="id"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-container>

              </v-form>
            </v-card-text>
            <v-divider></v-divider>

            <v-card-actions>
              <v-container grid-list-md fluid class="ma-0 pa-0">
                <v-layout row wrap class="ma-0 pa-0">
                  <v-flex xs12 md6 class="text-left">
                    <v-btn
                    v-if="eventData.dialogType == 'edit'""
                     icon
                      class="mr-2"
                      depressed
                      color="#8B93A6"
                      @click="deleteEventData(eventData)"
                      >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                    <v-btn
                      outlined
                      depressed
                      color="#8B93A6"
                      @click="closeEventData()"
                      >
                      Annuleren
                    </v-btn>
                  </v-flex>
                  <v-flex xs12 md6 class="text-right">
                    <v-btn
                      v-if="eventData.dialogType == 'new'"
                      :disabled=" !changed || eventData.busy" 
                      :depressed="!changed || eventData.busy"  
                      :dark=" changed || eventData.busy"
                      :block="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs'"
                      rounded 
                      :color="companySecondaryColor" 
                      @click="addEvent()"
                      >
                      Toevoegen
                    </v-btn>
                    <v-btn
                      v-else
                      :disabled="!changed || eventData.busy" 
                      :depressed="!changed || eventData.busy"  
                      :dark=" changed || eventData.busy"
                      :block="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs'"
                      rounded 
                      :color="companySecondaryColor" 
                      @click="updateEvent()"
                      >
                      Opslaan
                      <v-icon right dark>chevron_right</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-actions>
          </v-card>
        </v-dialog>
 

     
    </div>


     <div v-else class="text-center pa-10">
        <v-icon size="40px" :color="companyPrimaryColor">mdi-phone-off</v-icon>
        <h4 class="my-4">Qcare is niet actief</h4>
        <p>
          <v-btn color="primary" text @click="openQcareSettings()">Aanpassen</v-btn>
        </p>
      </div>
  </div>

</template>


<script>

import db from "../firebase/init";
import moment from "moment"
import CompanySelector from "../components/elements/CompanySelector.vue";


export default {
  name: "QcareOverview",
  components: {
    CompanySelector
  },
  data: () => ({
    tab: '1',
    loading: true,
    tabTransition: false,
    today: moment().format("YYYY-MM-DD"),
    now: moment().format('YYYY-MM-DDTHH:mm'),
    ready: false,
    value: '',
    events: new Array(),
    eventsToday: new Array(),
    dragEvent: null,
    dragStart: null,
    createEvent: null,
    createStart: null,
    dateSelectorMenu: false,
    selectedDate: null,
    extendOriginal: null,
    intervalCount: 48,
    intervalMinutes: 10,
    eventData: new Object(),
    isDragging: false,
    scheduleExceptions: new Array(),
    statusTypes: [
      {
        id: 'open',
        name: 'Open'
      },
      {
        id: 'inProgress',
        name: 'In behandeling'
      },
      {
        id: 'closed',
        name: 'Afgerond'
      },
      {
        id: 'cancelled',
        name: 'Geannuleerd'
      }
    ],
    selectedWeek: {
      number: null,
      start: null,
      end: null,
    },
    eventTypes: [
      {
        id: 'callFlow',
        name: 'Terugbelverzoek'
      },
      {
        id: 'occupied',
        name: 'Bezet'
      }
    ],
    eventDialog: false,
    eventChanges: 0,


    eventDrag: null,
    eventsSnapshotListener: null,
    updateTimeInterval: null,
    originalEvent: null
  }),

  mounted () {
 

      this.updateTime()
    },

  created() {
    this.selectedDate = moment().format('YYYY-MM-DD')
    this.selectedWeek.number = moment(this.selectedDate).isoWeek();
    this.selectedWeek.start = moment(this.selectedDate).startOf('week').format("YYYY-MM-DD")
    this.selectedWeek.end = moment(this.selectedDate).endOf('week').format("YYYY-MM-DD")
    this.resetEventData()
    this.getScheduleExceptions(this.selectedDate);
    
    this.loadData()
  },

  beforeDestroy(){
    this.stopEventsSnapshotListener();
    this.stopNowTicker()
  },



  methods: {

    loadData(){
      this.loading = true;
      this.getEvents(this.selectedDate)
      this.loadEventsToday();
      this.loading = false;
    },

    stopNowTicker() {
      if (this.updateTimeInterval) {
        clearInterval(this.updateTimeInterval)
        this.updateTimeInterval = null
      }
    },

    /**
     * Load events for today
     */
    async loadEventsToday(){
      const today = moment().format('YYYY-MM-DD');
      this.eventsToday = [];
      const events = await db.collection("qcareEvents").where("branchId", "==", this.$store.state.activeBranchData.id).where("date", "==", today).get();

      events.forEach(event => {
        this.eventsToday.push(
          {...event.data(), 
            id: event.id,
            color: event.data().type == 'callFlow' ? '#1867c0' : '#636466', 
            title: event.data().type == 'callFlow' ? 'Terugbelverzoek' : 'Bezet',
            status: event.data().status ? event.data().status : 'open',
            start: `${event.data().date}T${event.data().start}`,
            end: `${event.data().date}T${event.data().end}`,
          }
        );
      });
    },

    /**
     * Open Qcare settings
     * Route to /qcare-settings
     */
    openQcareSettings(){
      this.$router.push('/qcare-settings')
    },

    formatDate(date, startFormat, endFormat){
      const format = startFormat ? startFormat : "YYYY-MM-DD";
      return moment(date, format).locale('nl').format(endFormat);
    },

    /**
     * Show calendar tab
     */
    showCalendar(){
      this.tab = '2';
      setTimeout(() => {
        this.ready = true;
        this.now = moment().format('YYYY-MM-DD HH:mm:ss');
        // this.scrollToTime()
      }, 300);
    },

    /**
     * Show overview tab
     */
    showOverview(){
      this.tab = '1';
      this.loadEventsToday();
      this.ready = true;
    },

    /**
     * Delete event data
     * @param eventData - event data to delete
     */
    deleteEventData(eventData){
      db.collection("qcareEvents").doc(eventData.id).delete();
      this.events = this.events.filter(event => event.id !== eventData.id);
      this.closeEventData();
    },

    /**
     * Navigate to next or previous week
     * @param type - type of navigation (next or previous)
     */
    navigate(type){
      if(type == 'next'){
        this.selectedDate = moment(this.selectedDate).add(7, 'days').format('YYYY-MM-DD')
      }
      else if(type == 'previous'){
        this.selectedDate = moment(this.selectedDate).subtract(7, 'days').format('YYYY-MM-DD')
      }
      this.getScheduleExceptions(this.selectedDate);
      this.getEvents(this.selectedDate); 
    },

    /**
     * Check if the time is active to show in the calendar
     * @param date - date to check
     * @param time - time to check
     * @returns true if the time is active, false otherwise
     */
    checkForActive(date, time){
      let day = moment(date).locale('en').format('ddd');
      let valid = false;
      let exceptionPresentTimes = [];
      let exceptionAbsentTimes = [];
      let exceptionAbsentDay = false;
      let exceptionPresentDay = false;
      
      const exceptions = this.checkForScheduleException(date);
      if(exceptions.length > 0){
        for(let exception of exceptions){
          if(exception.type == 'absent'){
            if(exception.allDay){
              exceptionAbsentDay = true;
            }
            else{
              for(let time of exception.times){
                exceptionAbsentTimes.push({start: time.start, end: time.end})
              }
            }
          }
          if(exception.type == 'present'){
            exceptionPresentDay = true;
            for(let time of exception.times){
              exceptionPresentTimes.push({start: time.start, end: time.end})
            }
          }
        }
      }

      if((this.$store.state.activeBranchData.qcare.callBackSchedule[day] && this.$store.state.activeBranchData.qcare.callBackSchedule[day].active && !exceptionAbsentDay) || exceptionPresentDay){
       let times = JSON.parse(JSON.stringify(this.$store.state.activeBranchData.qcare.callBackSchedule[day].times))

       // Merge or subtract exceptions times with schedule times
       if(exceptionAbsentTimes.length > 0){
        times = this.subtractIntervals(times, exceptionAbsentTimes);
       }
       if(exceptionPresentTimes.length > 0){
        times = this.mergeIntervals(times, exceptionPresentTimes);
       }


        for(let scheduleTime of times){
         
          if(moment(time, "HH:mm").format("HH:mm") >= scheduleTime.start && moment(time, "HH:mm").format("HH:mm") < scheduleTime.end){
            valid = true
          }
        } 
      }
      return valid
    },

    updateTime () {
      
      this.updateTimeInterval = setInterval(() => {
        this.now = moment().format('YYYY-MM-DD HH:mm:ss');
        // const calendar = this.$refs.calendar;
        // if(calendar){
        //   console.log("updateTime: ",   calendar.times.now.minute)
        //   calendar.updateTimes();
        // }
      }, 10000) // elke 5 seconden updaten
    },

    /**
     * Subtract intervals
     * @param presence - array of intervals
     * @param absence - array of intervals
     * @returns array of intervals
     */
    subtractIntervals(presence, absence) {
      // Helper om tijd naar minuten te converteren
      const toMinutes = (timeStr) => {
        const [h, m] = timeStr.split(":").map(Number);
        return h * 60 + m;
      };

      // Helper om minuten terug naar HH:MM te converteren
      const toTimeStr = (mins) => {
        const h = String(Math.floor(mins / 60)).padStart(2, '0');
        const m = String(mins % 60).padStart(2, '0');
        return `${h}:${m}`;
      };

      // Zet alle tijden naar minuten voor eenvoudige berekeningen
      const presenceMin = presence.map(p => ({
        start: toMinutes(p.start),
        end: toMinutes(p.end)
      }));

      const absenceMin = absence.map(a => ({
        start: toMinutes(a.start),
        end: toMinutes(a.end)
      }));

      let result = [];

      for (let p of presenceMin) {
        let chunks = [p]; // Begin met het volledige aanwezigheid-interval

        for (let a of absenceMin) {
          let newChunks = [];
          for (let chunk of chunks) {
            if (a.end <= chunk.start || a.start >= chunk.end) {
              // Geen overlap
              newChunks.push(chunk);
            } else {
              // Er is overlap, splits eventueel op
              if (a.start > chunk.start) {
                newChunks.push({ start: chunk.start, end: a.start });
              }
              if (a.end < chunk.end) {
                newChunks.push({ start: a.end, end: chunk.end });
              }
            }
          }
          chunks = newChunks;
        }

        result.push(...chunks);
      }

      // Converteer terug naar HH:MM
      return result.map(r => ({
        start: toTimeStr(r.start),
        end: toTimeStr(r.end)
      }));
    },

    /**
     * Merge intervals
     * @param presence - array of intervals
     * @param extraPresence - array of intervals
     * @returns array of intervals
     */
    mergeIntervals(presence, extraPresence) {
      // Helper om tijd naar minuten te converteren
      const toMinutes = (timeStr) => {
        const [h, m] = timeStr.split(":").map(Number);
        return h * 60 + m;
      };

      // Helper om minuten naar HH:MM te converteren
      const toTimeStr = (mins) => {
        const h = String(Math.floor(mins / 60)).padStart(2, '0');
        const m = String(mins % 60).padStart(2, '0');
        return `${h}:${m}`;
      };

      // Alle intervallen combineren en sorteren op starttijd
      const all = [...presence, ...extraPresence]
        .map(p => ({ start: toMinutes(p.start), end: toMinutes(p.end) }))
        .sort((a, b) => a.start - b.start);

      let result = [];

      for (let interval of all) {
        if (result.length === 0) {
          result.push(interval);
        } else {
          let last = result[result.length - 1];
          if (interval.start <= last.end) {
            // Overlap of aansluiting -> samenvoegen
            last.end = Math.max(last.end, interval.end);
          } else {
            // Geen overlap -> nieuw interval
            result.push(interval);
          }
        }
      }

      // Zet terug naar HH:MM
      return result.map(r => ({
        start: toTimeStr(r.start),
        end: toTimeStr(r.end)
      }));
    },

    getCurrentTime () {
      const calendar = this.$refs.calendar;
      return calendar ? (calendar.times.now.hour * 60) + calendar.times.now.minute : 0
    },

    /**
     * Scroll to time
     */
    scrollToTime () {
      const time = this.getCurrentTime()
      const first = Math.max(0, time - (time % 30) - 30)
      const calendar = this.$refs.calendar;
      if(calendar){

        calendar.scrollToTime(first)
      }
    },
    // updateTime () {
    //   setInterval(() => {
    //     console.log("update time")
    //     // this.cal.updateTimes(), 60 * 1000;
    //     console.log("this.cal.times.now interval: ", this.cal.times.now)
    //   }, 5000)
    // },

    closeEventData(){
      this.resetEventData();
      this.removeConceptEvents();
    },

    /**
     * Get event type
     * @param type - type of event
     * @returns event type
     */
    getEventType(type){
     let selectedEventType = this.eventTypes.find(eventType =>{ return eventType.id == type})
     return selectedEventType ? selectedEventType.name : ""
    },

    /**
     * Remove concept events
     */
    removeConceptEvents(){
      this.events =this.events.filter(event => {return !event.concept})
    },

    /**
     * Reset event data
     */
    resetEventData(){
      this.eventData = {
        title: "",
        type: "callFlow",
        notes: "",
        color:'#cccccc',
        phone: "",
        start: null,
        end: null,
        status: 'open',
        busy: false,
        feedback: false,
        dialogType: 'new',
        dialog: false
      }
    },

    /**
     * Open event
     * @param data - event data
     */
    async openEvent(data){
    
    
    

      if (this.isDragging) {
            // was een drag, geen gewone klik
            this.isDragging = false; // reset
            return;
        }
      this.eventData.title = data.event.title;
      this.eventData.type = data.event.type;
      this.eventData.notes = data.event.notes;
      this.eventData.phoneNumber = data.event.phoneNumber;
      this.eventData.start = data.event.start;
      this.eventData.end = data.event.end;
      this.eventData.dialogType = 'edit';
      this.eventData.status = data.event.status;
      this.eventData.id = data.event.id;
      this.eventData.dialog = true
 
    },

    /**
     * Add event
     */
    async addEvent(){
      if(this.eventData.type){
       
        let event = {
          title: this.eventData.title,
          type: this.eventData.type,
          notes: this.eventData.notes,
          color: this.eventData.type == 'callFlow' ? '#1867c0' : '#636466',
          phone: this.eventData.phoneNumber,
          status: this.eventData.status,
          start: this.eventData.start,
          end: this.eventData.end,
          created: {
            seconds: moment().unix()
          }
        }

        const docRef = await db.collection("qcareEvents").add({
          branchId: this.$store.state.activeBranchData.id,
          companyId: this.$store.state.activeCompanyData.id,
          date: moment(this.eventData.start).format("YYYY-MM-DD"),
          title: this.eventData.title,
          type: this.eventData.type,
          notes: this.eventData.notes,
          phoneNumber: this.eventData.phoneNumber ? this.eventData.phoneNumber : '',
          start: moment(this.eventData.start).format("HH:mm"),
          end: moment(this.eventData.end).format("HH:mm"),
          status: this.eventData.type == 'callFlow' ? 'open' : null,
          created: new Date(),
          updated: new Date(),
        });
        event.id = docRef.id;

   
        this.closeEventData()
    }
    else{
      this.eventData.feedback = "Geen type geselecteerd";
    }
  },
  
  /**
   * Update event
   */
  async updateEvent(){
      if(this.eventData.type){
        await db.collection("qcareEvents").doc(this.eventData.id).set({
          date: moment(this.eventData.start).format("YYYY-MM-DD"),
          title: this.eventData.title,
          type: this.eventData.type,
          notes: this.eventData.notes ? this.eventData.notes : '',
          status: this.eventData.status,
          phoneNumber: this.eventData.phoneNumber ? this.eventData.phoneNumber : '',
          start: moment(this.eventData.start).format("HH:mm"),
          end: moment(this.eventData.end).format("HH:mm"),
          updated: new Date(),
        },{merge: true});

        for(let event of this.events){
          if(event.id == this.eventData.id){
    
            event.status = this.eventData.status;
            event.updated = new Date();
            event.notes = this.eventData.notes;
            event.title = this.eventData.title;
            event.type = this.eventData.type;
            event.phoneNumber = this.eventData.phoneNumber;
            this.eventChanges++;
            break;
          }
        }
        for(let event of this.eventsToday){
          if(event.id == this.eventData.id){
       
            event.status = this.eventData.status;
            event.updated = new Date();
            event.notes = this.eventData.notes;
            event.title = this.eventData.title;
            event.type = this.eventData.type;
            event.phoneNumber = this.eventData.phoneNumber;
            this.eventChanges++;
            break;
          }
        }
        this.closeEventData()
    }
    else{
      this.eventData.feedback = "Geen type geselecteerd";
    }
  },

    intervalFormat(interval) {
    
      return interval.time;
    },

    extendBottom(event){
      // console.log("event: ", event)
    },

    startTime (tms) {
      this.resetEventData()
    
      const mouse = this.toTime(tms)

      if (this.eventDrag && this.dragTime === null) {
        const start = Number(moment(this.eventDrag.start).format('x'))
        this.dragTime = mouse - start
      }
      else {
        this.createStart = this.roundTime(mouse)
        let createStart = moment(this.roundTime(mouse)).format("YYYY-MM-DDTHH:mm")
        this.createEvent = {
          title: '',
          id: Date.now(),
          color: '#cccccc',
          type: null,
          start: createStart,
          end: createStart,
          timed: true,
          concept: true,
          notes: ''
        }

        this.eventData.id = this.createEvent.id;
        this.eventData.start = createStart;
        this.eventData.end = createStart;
        this.eventData.dialogType = 'new';
        
        // console.log("Event push: ", createStart)
        this.events.push(this.createEvent)
      }
    },

    mouseMove (tms) {



      const mouse = this.toTime(tms)

      // console.log("this.eventDrag: ", this.eventDrag)
      if (this.eventDrag && this.dragTime !== null) {
        const start = Number(moment(this.eventDrag.start).format('x'))
        const end = Number(moment(this.eventDrag.end).format('x'))
        const duration = end - start
        const newStartTime = mouse - this.dragTime
        const newStart = this.roundTime(newStartTime)
        const newEnd = newStart + duration
        this.eventDrag.start =  newStart
        this.eventDrag.end =  newEnd
        let eventIndex = this.events.findIndex((event)=>{ return event.id == this.eventDrag.id})
        this.events[eventIndex].start = moment(newStart, 'x').format("YYYY-MM-DDTHH:mm");
        this.events[eventIndex].end = moment(newEnd,'x').format("YYYY-MM-DDTHH:mm");

        db.collection("qcareEvents").doc(this.eventDrag.id).update({
          date: moment(newStart, 'x').format("YYYY-MM-DD"),
          start: moment(newStart, 'x').format("HH:mm"),
          end: moment(newEnd,'x').format("HH:mm"),
        });
     
      }
      else if (this.createEvent && this.createStart !== null) {
        const mouseRounded = this.roundTime(mouse, false)
        const min = Math.min(mouseRounded, this.createStart)
        const max = Math.max(mouseRounded, this.createStart)

        this.createEvent.start = min
        this.createEvent.end = max
        this.eventData.end = moment(max).format("YYYY-MM-DDTHH:mm");
      }
    },

    roundTime (time, down = true) {
        const roundTo = 5 // minutes
        const roundDownTime = roundTo * 60 * 1000

        return down
          ? time - time % roundDownTime
          : time + (roundDownTime - (time % roundDownTime))
      },

    toTime (tms) {
        return new Date(tms.year, tms.month - 1, tms.day, tms.hour, tms.minute).getTime()
      },

    rnd (a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a
    },
    rndElement (arr) {
      return arr[this.rnd(0, arr.length - 1)]
    },

    startDrag ({ event, timed }) {
      this.originalEvent = JSON.parse(JSON.stringify(this.events.find(e => e.id == event.id)))
      // console.log("startDrag", event, timed)
      this.isDragging = false;
      // console.log('startDrag',  event, timed )
      if (event && timed) {
        this.eventDrag = {
          id: event.id,
          start: event.start,
          end: event.end
        }
        this.dragTime = null
      }
 
    },

    endDrag (event) {
    
      if (this.createEvent) {
        // console.log(this.createEvent)
        this.eventData.dialog = true
      }
      this.isDragging = false;
      if(this.originalEvent.start != moment(this.eventDrag.start).format("YYYY-MM-DDTHH:mm")){
     
        this.isDragging = true;
     }

      this.dragTime = null
      this.eventDrag = null
      this.createEvent = null
      this.createStart = null
      this.extendOriginal = null
    },

    cancelDrag () {
      if (this.createEvent) {
        if (this.extendOriginal) {
          this.createEvent.end = this.extendOriginal
        }
        else {
          const i = this.events.indexOf(this.createEvent)
          if (i !== -1) {
            this.events.splice(i, 1);
          }
        }
      }

      // this.createEvent = null
      // this.createStart = null
      this.dragTime = null
      this.eventDrag = null
    },
    async getScheduleExceptions(selectedDate){
      this.scheduleExceptions = [];
      let date = selectedDate ? selectedDate : moment().format("YYYY-MM-DD")
      const selectedWeekStart = moment(date).startOf('week').format("YYYY-MM-DD")
      const selectedWeekEnd = moment(date).endOf('week').format("YYYY-MM-DD")

      const exceptions = await db.collection("branches").doc(this.$store.state.activeBranchData.id).collection("qcareScheduleExceptions").where("end", ">=", selectedWeekStart).get();
      exceptions.forEach(exception => {
        if(moment(exception.data().end).isSameOrAfter(selectedWeekStart) && moment(exception.data().start).isSameOrBefore(selectedWeekEnd)){
        this.scheduleExceptions.push({
          ...exception.data(),
            start: exception.data().start,
            end: exception.data().end
          });
        }
      });
    },

    async getEvents(selectedDate){
      this.stopEventsSnapshotListener();
      this.events = [];
      let date = selectedDate ? selectedDate : moment().format("YYYY-MM-DD")
      this.selectedWeek.number = moment(date).isoWeek();
      this.selectedWeek.start = moment(date).startOf('week').format("YYYY-MM-DD");
      this.selectedWeek.end = moment(date).endOf('week').format("YYYY-MM-DD");


      this.eventsSnapshotListener = await db
        .collection("qcareEvents")
        .where("branchId", "==", this.$store.state.activeBranchData.id)
        .where("date", ">=", this.selectedWeek.start)
        .where("date", "<=", this.selectedWeek.end)
        .onSnapshot((snapshot) => {
          snapshot.docChanges().forEach((change) => {
            if (change.type === "added") {
              this.events.push(
                {...change.doc.data(), 
                  color: change.doc.data().type == 'callFlow' ? '#1867c0' : '#636466', 
                  title: change.doc.data().type == 'callFlow' ? 'Terugbelverzoek' : 'Bezet',
                  start: `${change.doc.data().date}T${change.doc.data().start}`,
                  end: `${change.doc.data().date}T${change.doc.data().end}`,
                  status: change.doc.data().status,
                  timed: true,
                  id: change.doc.id,
                  status: change.doc.data().status ? change.doc.data().status : 'open'
                }
              );
            }
          });
        });


      this.loading = false
    },

    stopEventsSnapshotListener(){
      this.eventsSnapshotListener = null;
    },

    getEventColor (event) {
      if(event.type == 'callFlow'){
        if(event.status == 'open'){
          return '#1867c0';
        }
        else if(event.status == 'inProgress'){
          return '#FFA726';
        }
        else if(event.status == 'closed'){
          return '#66BB6A';
        }
        else if(event.status == 'cancelled'){
          return '#D50000';
        }
      }
      return event.color
    },

    checkForScheduleException(date){
      const exceptions = this.scheduleExceptions.filter(exception => {
        if(exception.period){
          return moment(exception.start).isSameOrBefore(date, 'day') && moment(exception.end).isSameOrAfter(date, 'day')
        }
        else{
          return moment(exception.start).isSame(date, 'day')
        }
      })
      return exceptions
    },
    getDateFromWeekday(weekdayAbbr) {
      const start = moment(this.selectedWeek.start);
      for (let i = 0; i < 7; i++) {
        const date = moment(start).add(i, 'days');
        if (date.locale('en').format('ddd') === weekdayAbbr) {
          return date.format('YYYY-MM-DD');
        }
      }
      return null; // als niet gevonden
    }
  },

  computed: {

    dayTime(){
      const startTimes = [];
      const endTimes = [];
      if(this.$store.state.activeBranchData.qcare.callBackSchedule){  
        let days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
        for(let day of days){
          if(this.$store.state.activeBranchData.qcare.callBackSchedule[day]){
            if(this.$store.state.activeBranchData.qcare.callBackSchedule[day].active){
              for(let scheduleTime of this.$store.state.activeBranchData.qcare.callBackSchedule[day].times){
                startTimes.push(scheduleTime.start)
                endTimes.push(scheduleTime.end)
              }
            }
          }
        }

        startTimes.sort((a,b)=>{return a.localeCompare(b)})
        endTimes.sort((a,b)=>{return b.localeCompare(a)})


        if(startTimes.length > 0 && endTimes.length > 0){
          const momentStart = moment(startTimes[0], 'HH:mm');
          const momentEnd = moment(endTimes[0], 'HH:mm');
          const totalMinutes = momentEnd.diff(momentStart,'minutes') + 60;
          const intervalCount = Math.ceil(totalMinutes / this.$store.state.activeBranchData.qcare.timeBlock)
          // console.log('start:', moment(startTimes[0], "HH:mm").subtract(30, 'minutes').format("HH:mm"))
          // console.log('end:', moment(endTimes[0], "HH:mm").add(30, 'minutes').format("HH:mm"))
          // console.log("intervalCount: ", intervalCount)

          return {
            start: moment(startTimes[0], "HH:mm").subtract(30, 'minutes').format("HH:mm"),
            end: moment(endTimes[0], "HH:mm").add(30, 'minutes').format("HH:mm"),
            intervalCount: intervalCount
          }
        }
        else{
          const momentStart = moment("00:00", 'HH:mm');
          const momentEnd = moment("17:00", 'HH:mm');
          const totalMinutes = momentEnd.diff(momentStart,'minutes')
          const intervalCount = Math.ceil(totalMinutes / this.$store.state.activeBranchData.qcare.timeBlock)
        // console.log("intervalCount: ", intervalCount)
          return {
            start: "09:00",
            end: "17:00",
            intervalCount: intervalCount
          }
        }
      }
      else{
        const momentStart = moment("09:00", 'HH:mm');
        const momentEnd = moment("17:00", 'HH:mm');
        const totalMinutes = momentEnd.diff(momentStart,'minutes')
        const intervalCount = Math.ceil(totalMinutes / this.$store.state.activeBranchData.qcare.timeBlock)
     
        return {
          start: "09:00",
          end: "17:00",
          intervalCount: intervalCount
        }
      }
    },

    cal () {
      return this.ready ? this.$refs.calendar : null
    },
    nowY () {
      this.now
      let now = {
        date: moment().format('YYYY-MM-DD'),
        day: +moment().format('D'),
        hasDay: true,
        hasTime: true,
        present: true,
        future: false,
        hour: +moment().format('H'),
        minute: +moment().format('mm'),
        time: moment().format('HH:mm'),
        year: +moment().format('YYYY'),
        month: +moment().format('M'),

      }
      if(this.$refs.calendar){
        return this.$refs.calendar.timeToY(now) + 'px'
      }
      return '-10px'
    },

    changed(){
      return true
    },
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    }
  }
};
</script>

<style>
  .v-current-time {
    height: 2px;
    width: 100%;
    background-color: #ea4335;
    position: absolute;
    left: -1px;
    right: 0;
    pointer-events: none;
  }

  .event-info-wrapper{
    padding: 3px 5px;
    height: 100%;
  }

  .event-info-banner{
    background-color: rgba(255,255,255,0.2);
    border-radius: 3px;
    padding: 2px 1px;
  }
  .event-info-phone{
    color: #ffffff!important;
    font-size: 12px;
    margin-top: 4px;
  }
  .event-info-phone a{
    color: #ffffff!important;
  }
  .event-info-banner-title{
    color: #ffffff
  }
  .event-info-banner-time,
  .event-info-banner,
  .event-info-description{
    color: #ffffff
  }

  .v-event-timed {
  user-select: none;
  -webkit-user-select: none;
}

.v-event-drag-bottom {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 4px;
  height: 4px;
  cursor: ns-resize;

  &::after {
    display: none;
    position: absolute;
    left: 50%;
    height: 4px;
    border-top: 1px solid white;
    border-bottom: 1px solid white;
    width: 16px;
    margin-left: -8px;
    opacity: 0.8;
    content: '';
  }

  &:hover::after {
    display: block;
  }
}

.v-current-time {
  height: 2px;
  background-color: #ea4335;
  position: absolute;
  left: -1px;
  right: 0;
  pointer-events: none;

  &.first::before {
    content: '';
    position: absolute;
    background-color: #ea4335;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-top: -5px;
    margin-left: -6.5px;
  }
}

.inactive-interval{
  background-color: var(--v-background-base);;
}

.v-calendar-daily_head-weekday{
  display: none;
}
.qcare-wrapper .v-tabs-items{
  background: none!important;
}

</style>
